/* global PdfSignExtension */

import React, { useState, useContext, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation, Link } from "react-router-dom";
import { Row, Column } from "../../../../../common/columns";
import Pdf from "../../../../../common/pdfView/pdfView";
import { cleanJoin } from "../../../../../utils/stringUtil";
import { POST } from "../../../../../utils/fetchUtil";
import { format } from "date-fns";
import { MessageContext } from "../../../../../common/message";
import { getAccessToken } from "../../../../../common/authorization/AuthorizeService";
import Loader from "../../../../../common/loader/Loader";
import Modal from "../../../../../common/modal/Modal";
import { UserContext } from "../../../../../common/user/UserContext";

function DecisionPreviewPage() {
  const location = useLocation();
  const { t } = useTranslation();
  const message = useContext(MessageContext);
  const [isLoading, setIsLoading] = useState(true);
  const user = useContext(UserContext);

  const history = useHistory();

  const [href, setHref] = useState(location.state[0].substring(9, location.state[0].length - 2));
  const [newHref, setNewHref] = useState(href);
  const [isStampedOrSigned, setIsStampedOrSigned] = useState(false);
  const [stampInProgress, setStampInProgress] = useState(false);
  const fileName = location.state[1];
  const requestName = location.state[2];
  const submissionDate = format(new Date(location.state[3]), "dd.MM.yyyy");
  const subject = location.state[4];
  const requestId = location.state[5];
  const submissionId = location.state[6];
  const file = location.state[7];

  // const [verificationCode, setVerificationCode] = useState("");
  // const [signUrl, setSignUrl] = useState("");
  // const [isModalActive, setIsModalActive] = useState(null);
  // const [isUploadInProgress, setIsUploadInProgress] = useState(false);
  // const [signInProgress, setSignInProgress] = useState(false);

  const opener = (url, verificationCode) => {
    const myWindow = window.open(url, "Potpis", "width=850,height=600");

    var timer = setInterval(function () {
      if (myWindow.closed) {
        uploadSigned(verificationCode);
        clearInterval(timer);
      }
    }, 1000);
  };

  const upload = async (signature, nameSurname, oib) => {
    const formData = new FormData();
    // setIsUploadInProgress(true);
    // setSignInProgress(true);

    formData.append("files", file);

    if (signature === "true") {
      formData.append("VisibleSignature", signature);
      formData.append("NameSurname", nameSurname);
      formData.append("oib", oib);
    }

    const request = new XMLHttpRequest();

    request.open("POST", "https://epotpis-test.dokumentit.hr/potpisi");

    request.setRequestHeader("X-Api-Key", "secrethkms");

    request.send(formData);

    request.onreadystatechange = () => {
      if (request.readyState === 4 && request.status === 200) {
        const response = JSON.parse(request.responseText);
        /*  MODAL WAY */
        // setSignUrl(response.signUrl);
        // setVerificationCode(response.files[0].verificationCode);
        // setIsUploadInProgress(false);

        opener(response.signUrl, response.files[0].verificationCode);
        /* FOR MODAL */
        //setIsModalActive(true);
      }
    };
  };

  const uploadSigned = useCallback(
    (verification) => {
      let headers = new Headers();
      headers.append("X-Api-key", "secrethkms");

      let requestOpts = {
        method: "GET",
        headers: headers,
        redirect: "follow",
      };

      fetch(
        `https://epotpis-test.dokumentit.hr/dohvatiPotpisaniDokument/${verification}.pdf`,
        requestOpts
      )
        .then((response) => {
          if (response.ok) {
            return response.arrayBuffer();
          } else throw new Error("Greška: Dohvat potpisanog dokumenta nije uspio.");
          //  && setSignInProgress(false)
        })
        .then((result) => {
          let headers = new Headers();
          headers.append("Request-Origin", "pisarnica");
          let uInt8Array = new Uint8Array(result);

          let blob = new Blob([uInt8Array]);
          let form = new FormData();
          form.append("File", blob, fileName + ".pdf");
          form.append("Id", submissionId);

          let requestOptions = {
            method: "POST",
            headers: headers,
            body: form,
            redirect: "follow",
          };

          fetch(`${process.env.REACT_APP_GATEWAY_URL}/upload`, requestOptions)
            .then((response) => {
              if (response.ok) {
                return response.text();
              } else throw new Error("Došlo je do pogreške prilikom potpisivanja dokumenta.");
            })
            .then((result) => {
              setNewHref(result.substring(9, result.length - 2));
              setIsStampedOrSigned(true);
              //setSignInProgress(false);
            })
            .catch((error) => {
              console.log("error", error);
            });
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    [fileName, submissionId]
  );

  async function fetchDoc() {
    fetch(`${process.env.REACT_APP_GATEWAY_URL}${href}`, {
      method: "GET",
      headers: {
        "Request-Origin": "pisarnica",
        Authorization: "Bearer " + (await getAccessToken()),
      },
      mode: "cors",
      credentials: "include",
    })
      .then((response) => response.blob())
      .then((file) => {
        setHref(window.URL.createObjectURL(file));
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    if (isLoading) fetchDoc();
  }, [isLoading]);

  // useEffect(() => {
  //   if (!isModalActive && signInProgress) {
  //     uploadSigned();
  //   }
  // }, [isModalActive]);

  const decisionSend = () => {
    message.toggle({
      title: t("requests.decisionAcceptance.title"),
      content: t("requests.decisionAcceptance.sendMsg"),
      onNo: () => message.toggle({}),
      onYes: () => {
        message.toggle({});
        POST(
          `/requests/${requestId}/submissions/${submissionId}/decision`,

          { link: newHref, label: "" },
          () => {
            message.toggle({
              title: t("requests.decisionAcceptance.title"),
              content: t("requests.decisionAcceptance.sendInfo"),
              hideNo: true,
              yesLabel: t("modalMessage.okLabel"),
              onYes: () => {
                message.toggle({});
                history.push(`/resolvedRequests`);
              },
            });
          },
          (error) => {
            message.toggle({
              title: t("requests.reviewDocuments.action.save.error"),
              content: error,
              hideNo: true,
              yesLabel: t("modalMessage.okLabel"),
              onYes: () => {
                message.toggle({});
              },
            });
          }
        ); /* .then(() => {
          message.toggle({
            title: t("requests.decisionAcceptance.title"),
            content: t("requests.decisionAcceptance.sendInfo"),
            hideNo: true,
            yesLabel: t("modalMessage.okLabel"),
            onYes: () => {
              message.toggle({});
              history.push(`/resolvedRequests`);
            },
          });
        }); */
      },
    });
  };

  /* ASPOSE SIGNING */

  // const signPdf = async (pdf) => {
  //   if (pdf) {
  //     var uint8Array;
  //     pdf.arrayBuffer().then((buffer) => {
  //       uint8Array = new Uint8Array(buffer);

  //       if (typeof PdfSignExtension !== "undefined") {
  //         PdfSignExtension.Setup({ languageId: "eng" });
  //         PdfSignExtension.SignPdf(
  //           {
  //             pdfContent: uint8Array,
  //             signatureType: 1,
  //             onlyValidCertificate: false,
  //           },
  //           async function (data) {
  //             const file = new Blob([data.buffer], { type: "application/pdf" });
  //             const formData = new FormData();
  //             formData.append("file", file, newHref.split("/").pop());
  //             const request = new XMLHttpRequest();
  //             request.onload = checkForHttpErrors(request);
  //             request.open("POST", `${process.env.REACT_APP_GATEWAY_URL}/upload`);

  //             //identity

  //             let token = await getAccessToken();

  //             request.setRequestHeader("Request-Origin", "pisarnica");
  //             request.setRequestHeader("Authorization", `Bearer ${token}`);

  //             request.send(formData);
  //             request.onreadystatechange = function () {
  //               if (this.readyState === 4) {
  //                 setNewHref(request.response.substring(9, request.response.length - 2));
  //                 setIsStampedOrSigned(true);
  //                 message.toggle({
  //                   title: t("modalMessage.titleInfo"),
  //                   content: t("requests.decisionAcceptance.action.signed"),
  //                   hideNo: true,
  //                   yesLabel: t("modalMessage.okLabel"),
  //                   onYes: () => message.toggle({}),
  //                 });
  //               }
  //             };
  //           },
  //           function (data) {
  //             alert(data.ErrorStacktrace);
  //           },
  //           function () {},
  //           function () {}
  //         );
  //       }
  //     });
  //   }
  // };

  const decisionStamp = () => {
    setStampInProgress(true);
    message.toggle({
      title: t("modalMessage.titleInfo"),
      content: t("requests.decisionAcceptance.wait"),
      hideNo: true,
      yesLabel: t("modalMessage.okLabel"),
      onYes: () => message.toggle({}),
    });
    POST(
      `/requests/${requestId}/submissions/${submissionId}/digitallyStamp`,
      { link: newHref, label: "" },
      (data) => {
        setStampInProgress(false);
        setNewHref(data.href);
        setIsStampedOrSigned(true);
        message.toggle({
          title: t("modalMessage.titleInfo"),
          content: t("requests.decisionAcceptance.action.stamped"),
          hideNo: true,
          yesLabel: t("modalMessage.okLabel"),
          onYes: () => message.toggle({}),
        });
      },
      (error) => {
        setStampInProgress(false);
        message.toggle({
          title: t("requests.reviewDocuments.action.save.error"),
          content: error,
          hideNo: true,
          yesLabel: t("modalMessage.okLabel"),
          onYes: () => {
            message.toggle({});
          },
        });
      }
    );
  };

  if (!stampInProgress) {
    return (
      <>
        {/*  MODAL WAY */
        /* <Modal
          isActive={isModalActive}
          setIsActive={setIsModalActive}
          render={
            () => {
              signUrl &&
                window.open(signUrl, "Potpis", "menubar=1,resizable=1,width=850,height=600");
            }
            // <iframe
            //   id={"signature-iframe"}
            //   className={"is-centered"}
            //   style={{
            //     overflow: "none",
            //     position: "relative",
            //     display: "flex",
            //     justifyContent: "center",
            //     flexDirection: "row",
            //   }}
            //   width={850}
            //   height={600}
            //   title="sdurdd"
            //   src={signUrl}
            // ></iframe>
          }
        /> */}
        <div className="block is-centered">
          <Row className="is-centered">
            <Column size={3} className="is-centered mt-5">
              <div className="block">
                <p className="has-text-weight-bold">{requestName}</p>
                <p>
                  {t("requests.documentAcceptance.submissionDate")}
                  {submissionDate}
                </p>
                <p>
                  {t("requests.documentAcceptance.subject")}
                  {subject}
                </p>
                {isStampedOrSigned && (
                  <button
                    className={
                      "button is-light has-background-white-ter is-size-7 has-text-weight-bold"
                    }
                    style={{ zIndex: 1000 }}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={async () =>
                      fetch(`${process.env.REACT_APP_GATEWAY_URL}${newHref}`, {
                        method: "GET",
                        headers: {
                          "Request-Origin": "pisarnica",
                          Authorization: "Bearer " + (await getAccessToken()),
                        },
                        mode: "cors",
                        credentials: "include",
                      })
                        .then((response) => response.blob())
                        .then((file) => window.open(URL.createObjectURL(file)))
                    }
                  >
                    {t("requests.decisionAcceptance.stampInfo")}
                  </button>
                )}
              </div>
            </Column>

            <Column size={4} className="is-centered">
              {isLoading ? <Loader /> : <Pdf path={href} />}{" "}
            </Column>

            <Column size={3} className="is-centered"></Column>
          </Row>

          <Row className="buttons is-centered is-grouped">
            <Link
              to={{
                pathname: `/requirementsInResolving`,
              }}
              rel="noopener noreferrer"
              className="is-pulled-left"
            >
              <button
                id="remove"
                className={cleanJoin(
                  "button",
                  "document-acceptance-button",
                  "no-focus-outline",
                  "has-border-red-1",
                  "has-background-danger-on-hover has-text-white-on-hover has-opacity-71-on-hover"
                )}
              >
                {t("requests.decisionAcceptance.action.remove")}
              </button>
            </Link>

            <button
              id="submit"
              className={cleanJoin(
                "button",
                "document-acceptance-button",
                "no-focus-outline",
                "has-border-green-1",
                "has-background-green-on-hover has-text-white-on-hover has-opacity-71-on-hover"
              )}
              onClick={() => decisionSend()}
            >
              {t("requests.decisionAcceptance.action.send")}
            </button>

            <button
              id="sign"
              className={cleanJoin(
                "button",
                "document-acceptance-button",
                "no-focus-outline",
                "has-border-green-1",
                "has-background-green-on-hover has-text-white-on-hover has-opacity-71-on-hover"
              )}
              onClick={() => {
                message.toggle({
                  show: true,
                  title: "Potpisivanje dokumenta",
                  content: "Želite li vidljivi potpis na vašem dokumentu?",
                  yesLabel: "Da",
                  noLabel: "Ne",

                  onX: () => {
                    message.toggle({ show: false });
                  },

                  onYes: async () => {
                    await upload("true", user.signUser.nameSurname, user.signUser.oib);
                    message.toggle({ show: false });
                  },
                  onNo: async () => {
                    await upload("false", user.signUser.nameSurname, user.signUser.oib);
                    message.toggle({ show: false });
                  },
                });
              }}
            >
              {t("requests.decisionAcceptance.action.sign")}
            </button>

            <button
              id="stamp"
              className={cleanJoin(
                "button",
                "document-acceptance-button",
                "no-focus-outline",
                "has-border-green-1",
                "has-background-green-on-hover has-text-white-on-hover has-opacity-71-on-hover"
              )}
              onClick={() => decisionStamp()}
            >
              {t("requests.decisionAcceptance.action.stamp")}
            </button>
          </Row>
        </div>
      </>
    );
  } else {
    return <Loader />;
  }
}

export default DecisionPreviewPage;
